export const CART_STATES = [
  {left: '-500px'},
  {left: '-367px'},
  {left: '10px'},
  {top: '-1000px'},
  {top: '-206px'},
  {top: '0'}
]

export const MOBILE_VIEW_OFFSET_STATES = 3


// WEBPACK FOOTER //
// ./src/features/Cart/containers/Cart/constants.js